// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2y3Wp","label":"CategoryService_label__1uUM9","location":"CategoryService_location__1szGN"};